import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { BckpFeatureKey } from '@apps/bckp/bckp.constants';
import { BckpReducers } from './bckp.reducer';

import { BckpDashboardEffects } from './dashboard/dashboard.effects';
import { BckpJobEffects } from './jobs/jobs.effects';
import { BckpServersServEffects } from './servers/serv/serv.effects';
import { BckpOptionsEffects } from './common/options/options.effects';
import { BckpCapacitiesEffects } from './capacities/capacities.effects';
import { BckpPoliciesEffects } from './policies/policies.effects';
import { BckpCopiesCurrEffects } from './copies/curr/curr.effects';
import { BckpCopiesEvolEffects } from './copies/evol/evol.effects';
import { BckpServersHeatEffects } from '@apps/bckp/store/servers/heat/heat.effects';
import { BckpVbrDashboardEffects } from './veeam/vbr/vbr-dashboard/vbr-dashboard.effects';
import { BckpVboDashboardEffects } from './veeam/vbo/vbo-dashboard/vbo-dashboard.effects';
import { BckpVbrJobEffects } from './veeam/vbr/jobs/vbr-jobs.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        EffectsModule.forFeature([
            BckpDashboardEffects,
            BckpJobEffects,
            BckpServersServEffects,
            BckpServersHeatEffects,
            BckpOptionsEffects,
            BckpCapacitiesEffects,
            BckpPoliciesEffects,
            BckpCopiesCurrEffects,
            BckpCopiesEvolEffects,
            BckpVbrDashboardEffects,
            BckpVboDashboardEffects,
            BckpVbrJobEffects
        ]),
        StoreModule.forFeature(
            BckpFeatureKey,
            BckpReducers
        )
    ]
})
export class BckpStoreModule
{ }
